import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2022DatosGenerales() {
  return <CategoryPage category="anexo30Y31Ano2022DatosGenerales" pageTitle="Datos Generales 2022" />;
}

export default Anexo30Y31Ano2022DatosGenerales;
